import { render, staticRenderFns } from "./PersonsImport.vue?vue&type=template&id=0f787296&"
import script from "./PersonsImport.vue?vue&type=script&lang=js&"
export * from "./PersonsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports